<template>
	<b-form>

    <div class="bg-light-form text-center">
      <h1>Not implemented</h1>
      New features coming soon
    </div>

		<b-row>
			<b-col xl="3" md="3" sm="12">
				<div class="mt-2 d-none">
					<label for="customer" class="font-weight-900 text-sm">Customer</label>
					<b-form-select
						id="customer"
						v-model="diameterGraphForm.customer"
						:options="customerOption"
						value-field="key"
						text-field="value"
					></b-form-select>
				</div>

				<div class="mt-2">
					<label for="period" class="font-weight-900 text-sm">Period</label>
					<b-form-select
						id="period"
						v-model="diameterGraphForm.period"
						:options="periodOption"
						value-field="key"
						text-field="value"
						@change="getSelectedDate(diameterGraphForm.period)"
					></b-form-select>
				</div>
				<div class="mt-2" v-if="selectDayStatus">
					<label for="selectDay" class="col-form-label form-control-label">Select Day:</label>
					<base-input
						type="date"
						v-model="diameterGraphForm.dynamicDate"
						id="selectDay"
						@change="selectDate()"
					/>
				</div>

				<div class="mt-2" v-if="selectWeekStatus">
					<label for="selectWeek" class="col-form-label form-control-label">Select Week:</label>
					<base-input
						type="week"
						v-model="diameterGraphForm.dynamicDate"
						id="selectWeek"
						@change="selectWeek()"
					/>
				</div>

				<div class="mt-2" v-if="selectMonthStatus">
					<label for="selectMonth" class="col-form-label form-control-label">Select Month:</label>
					<b-form-select
						id="selectMonth"
						v-model="diameterGraphForm.dynamicDate"
						:options="monthOption"
						value-field="key"
						text-field="value"
						@change="selectMonth()"
					></b-form-select>
				</div>

				<div class="mt-2">
					<label for="timeSeries" class="font-weight-900 text-sm">Time Series</label>
					<b-form-select
						id="timeSeries"
						v-model="diameterGraphForm.timeSeries"
						:options="seriesOption"
						value-field="key"
						text-field="value"
					></b-form-select>
				</div>
				<div class="mt-2">
					<label for="grouping" class="font-weight-900 text-sm">Data Grouping</label>
					<b-form-select
						id="grouping"
						v-model="diameterGraphForm.dataGrouping"
						:options="groupingOption"
						value-field="key"
						text-field="value"
					></b-form-select>
				</div>
				<hr class="mt-3 mb-3" />
				<div class="text-right">
					<base-button type="primary" title="Search" size="sm" v-on:click="updateGraph" :loading="loadingStatus" class="mb-3">
						  Update Graph
					</base-button>
				</div>
			</b-col>
			<b-col xl="1" md="1" sm="12"></b-col>
			<b-col xl="8" md="8" sm="12">
				<div class="diameter-highchart text-center">
					<div class="text-center w-100">
						<b-icon
							icon="three-dots"
							class="text-center loading-icon-style"
							animation="cylon"
							font-scale="4"
							v-if="loadingStatus"
						></b-icon>
					</div>
					<highcharts :options="chartOptions" v-if="!loadingStatus"></highcharts>
				</div>
			</b-col>
		</b-row>
	</b-form>
</template>

<script>
import configDirective from "../../../../common/directive/config-directive";
import moment from "moment";
import diameterService from "../../../../common/api-services/diameter-service";

export default {
	name: "Diameter-Graph",
	components: {},
	data() {
		return {
			diameterGraphForm: {
				customer: "",
				period: "6h",
				dynamicDate: "",
				timeSeries: "1h",
				dataGrouping: "type",
			},
			periodOption: [
				{key: "24h", value: "Last 24 hours"},
				{key: "6h", value: "Last 6 hours"},
				{key: "1h", value: "Last 1 hours"},
				{key: "daily", value: "Daily"},
				{key: "weekly", value: "Weekly"},
				{key: "monthly", value: "Monthly"},
			],
			seriesOption: [
				{key: "5m", value: "5 Minutes"},
				{key: "1h", value: "1 Hour"},
				{key: "1d", value: "1 Day"},
				{key: "7d", value: "1 Week"},
				{key: "30d", value: "1 Month"},
			],
			groupingOption: [
				{key: "", value: "Total Messages"},
				{key: "type", value: "Type"},
				{key: "command_id", value: "Command"},
				{key: "imsi", value: "IMSI"},
				{key: "orealm_req", value: "Realm"},
			],
			monthOption: [],
			customerOption: [],
			selectDayStatus: false,
			selectWeekStatus: false,
			selectMonthStatus: false,
			loadingStatus: false,
			selectedDateFrom: "",
			selectedDateTo: "",
			timeRangeCondition: "",

			chartOptions: {
				title: {
					text: "Messages",
				},
				subtitle: {
					text: "",
				},
				yAxis: {
					title: {
						text: "",
					},
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "middle",
				},
				plotOptions: {
					series: {
						label: {
							connectorAllowed: false,
						},
						marker: {
							enabled: false,
						},
					},
				},
				xAxis: {
					categories: [],
					type: "datetime",
				},
				series: [],
				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								legend: {
									layout: "horizontal",
									align: "center",
									verticalAlign: "bottom",
								},
							},
						},
					],
				},
			},
		};
	},
	mounted() {
		this.diameterFunc();
	},
	methods: {
		diameterFunc() {
			this.loadingStatus = true;
			let url = configDirective.getInfluxSettingsUrl();
			let db = configDirective.getInfluxSettingsDB();
			let configCustomer = configDirective.getInfluxSettingCustomer();

			this.timeRangeCondition = this.getTimeRangeCondition(this.diameterGraphForm.period);

			let customerCondition = " AND customer = '" + configCustomer + "' AND imsi !='0' ";
			if (customerCondition === "PORTAL_ADMIN") {
				customerCondition = " AND imsi =~ /" + this.diameterGraphForm.customer + "*/  ";
			}

			let groupingCondition = "";
			if (this.diameterGraphForm.dataGrouping !== "") {
				groupingCondition = "," + this.diameterGraphForm.dataGrouping;
			}

			let query =
				'SELECT count("message_count") ' +
				'FROM "diameter_usage" ' +
				"WHERE " +
				this.timeRangeCondition +
				" " +
				customerCondition +
				"GROUP BY time(" +
				this.diameterGraphForm.timeSeries +
				")" +
				groupingCondition;

			let apiURL = url + "?db=" + db + "&pretty=true&q=" + query;
			diameterService.getUpdateGraph(apiURL).then(res => {
				this.loadingStatus = false;
				this.chartOptions.series = [];
				if (res && res.length > 0) {
					let series = res[0].series;
					let browserDate = new Date();
					let timeZoneOffset = browserDate.getTimezoneOffset() * 60 * 1000;
					if (series) {
						series.map(item => {
							let gData = [];
							let gLabel = [];
							item.values.map((indexItem, index) => {
								gData.push(indexItem[1]);
								gLabel.push(indexItem[0]);
							});
							this.chartOptions.xAxis.categories = gLabel;
							let legendTitle;
							if (this.diameterGraphForm.dataGrouping) {
								legendTitle = item.tags[this.diameterGraphForm.dataGrouping];
							} else {
								legendTitle = "Total Messages";
							}
							this.chartOptions.series.push({
								name: legendTitle,
								data: gData,
							});
						});
					}
				}
			});
		},

		updateGraph() {
			if (this.diameterGraphForm.period === "monthly" && this.diameterGraphForm.dynamicDate === "empty") {
				this.$toast.error('Error - Please select valid reporting period')
				return false;
			}
			this.diameterFunc();
		},

		getSelectedDate(option) {
			switch (option) {
				case "daily": {
					this.selectDayStatus = true;
					this.selectWeekStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentDate();
					break;
				}
				case "weekly": {
					this.selectWeekStatus = true;
					this.selectDayStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentWeek();
					break;
				}
				case "monthly": {
					this.selectMonthStatus = true;
					this.selectDayStatus = false;
					this.selectWeekStatus = false;
					this.getCurrentMonth();
					break;
				}
				default:
					this.selectMonthStatus = false;
					this.selectDayStatus = false;
					this.selectWeekStatus = false;
					break;
			}
		},

		getCurrentDate() {
			let date = new Date();
			let thisYear = date.getFullYear();
			let thisDate = date.getDate();
			let thisMonth = date.getMonth() + 1;
			if (thisDate < 10) {
				thisDate = "0" + thisDate;
			}
			if (thisMonth < 10) {
				thisMonth = "0" + thisMonth;
			}
			this.diameterGraphForm.dynamicDate = thisYear + "-" + thisMonth + "-" + thisDate;
			this.selectDate();
		},

		getCurrentWeek() {
			let today = new Date();
			let year = today.getFullYear();
			let oneJan = new Date(year, 0, 1);
			let numberOfDays = Math.floor((today - oneJan) / (24 * 60 * 60 * 1000));
			let result = Math.floor((today.getDay() + 1 + numberOfDays) / 7);
			this.diameterGraphForm.dynamicDate = year + "-W" + result;
			this.selectWeek();
		},

		getCurrentMonth() {
			this.monthOption = [];
			this.monthOption.push({
				key: "empty",
				value: "Select One",
			});
			let monthNames = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			let today = new Date();
			let year = today.getFullYear();
			let month = today.getMonth() + 1;
			let i = 0;
			do {
				let key = (month > 9 ? "" : "0") + month + "/01/" + year;
				let value = monthNames[month - 1] + " " + year;
				this.monthOption.push({
					key: key,
					value: value,
				});
				if (month - 1 < 1) {
					month = 13;
				}
				if (month === 0) {
					month = 11;
					year--;
				} else {
					month--;
				}
				i++;
			} while (i < 3);
			this.diameterGraphForm.dynamicDate = "empty";
			this.selectMonth();
		},

		getTimeRangeCondition(period) {
			let timeRangeCondition;
			switch (period) {
				case "24h": {
					timeRangeCondition = "time >= now() - " + this.diameterGraphForm.period;
					break;
				}
				case "6h": {
					timeRangeCondition = "time >= now() - " + this.diameterGraphForm.period;
					break;
				}
				case "1h": {
					timeRangeCondition = "time >= now() - " + this.diameterGraphForm.period;
					break;
				}
				case "daily": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				case "weekly": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				case "monthly": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				default:
					break;
			}
			return timeRangeCondition;
		},

		selectDate() {
			this.selectedDateFrom =
				moment(new Date(this.diameterGraphForm.dynamicDate)).format("YYYY-MM-DDT00:00:00") + "Z";
			this.selectedDateTo =
				moment(new Date(this.diameterGraphForm.dynamicDate)).format("YYYY-MM-DDT23:59:00") + "Z";
		},

		selectWeek() {
			let weekNum = this.diameterGraphForm.dynamicDate.split("W")[1];
			let year = this.diameterGraphForm.dynamicDate.split("-")[0].trim();
			let d = 1 + weekNum * 7;
			let newDate = new Date(Number(year), 0, d);
			let first = newDate.getDate() - newDate.getDay();
			let last = first + 6;

			let firstDay = new Date(newDate.setDate(first));
			let lastDay = new Date(newDate.setDate(last));
			if (first < 0) {
				lastDay = new Date(lastDay.getFullYear(), lastDay.getMonth() + 1, lastDay.getDate());
			}
			this.selectedDateFrom = moment(new Date(firstDay)).format("YYYY-MM-DDT00:00:00") + "Z";
			this.selectedDateTo = moment(new Date(lastDay)).format("YYYY-MM-DDT23:59:00") + "Z";
		},

		selectMonth() {
			let date = new Date(this.diameterGraphForm.dynamicDate);
			let y = date.getFullYear();
			let m = date.getMonth();
			let firstDay = moment(new Date(y, m, 1)).format("YYYY-MM-DDT00:00:00") + "Z";
			let lastDay = moment(new Date(y, m + 1, 0)).format("YYYY-MM-DDT23:59:00") + "Z";
			this.selectedDateFrom = firstDay;
			this.selectedDateTo = lastDay;
		},
	},
};
</script>

<style scoped>
.diameter-highchart {
	border: 10px solid #dee2e6;
	background-color: #dee2e6;
	min-height: 400px;
}
.loading-icon-style {
	position: fixed;
	height: 40%;
}
.cursor-no-allowed {
	cursor: not-allowed;
}
</style>
